import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@Components/Button';
import MainSectionLayout from '@Components/MainSectionLayout';
import SearchBar from '@Components/SearchBar';

import UsersLayoutProps from './UsersLayout.types';

const UsersLayout: FunctionComponent<UsersLayoutProps> = (
  props: UsersLayoutProps
): JSX.Element => {
  const {
    searchProps,
    showFilterControls,
    clearFilterBtnOnClick,
    ...resProps
  } = props;

  /** Translation Hook */
  const { t } = useTranslation();

  /** Page Heading */
  const headingText = t('Users.List Of Users');

  /** Table Filters */
  const filtersComponent = (
    <>
      <Box
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        gap={1.6}
        mb={1.6}
      >
        <SearchBar {...searchProps} maxWidth={33.3} />
      </Box>
      {showFilterControls && (
        <Box display="inline-flex" alignItems="center" ml={0}>
          <Button
            variant="text"
            color="secondary"
            icon="close"
            text={t('common.tableFilters.Clear Filters')}
            onClick={clearFilterBtnOnClick}
            sx={{ textTransform: 'none' }}
          />
        </Box>
      )}
    </>
  );

  return (
    <MainSectionLayout
      heading={headingText}
      filters={filtersComponent}
      {...resProps}
    />
  );
};

export default UsersLayout;
